import { ICallbacks } from './namespace';

export const initialOptions: ICallbacks = {
  onCreate: null,
  onSlideStart: null,
  onSlide: null,
  onSlideFinish: null,
  onUpdate: null,
};



// WEBPACK FOOTER //
// ./components/controller/initial.ts